import {useAuthUser} from "@/providers";
import {useEffect, useState} from "react";
import {Outlet} from "react-router-dom";
import {getAuthUser} from "@/api/apiMethods.ts";
import {AxiosError} from "axios";
import {FullScreenLoader} from "@/components/loader/FullScreenLoader.tsx";
import {Caption} from "@telegram-apps/telegram-ui";
import {useTranslation} from "react-i18next";

export const AuthLayout = () => {
  const { setAuthUser } = useAuthUser();
  const [ isLoaded, setIsLoaded ] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchUserData = async () => {
      return await getAuthUser();
    };

    fetchUserData().then((user)=>{
      setAuthUser(user);
      setIsLoaded(true);
    }).catch((error) => {
      if (error instanceof AxiosError) {
        if (error.response && error.response.status === 401) {
          setAuthUser(null);
          return;
        }
      }
      setIsLoaded(true);
      console.error(error);
    });
  }, [setAuthUser]);

  if (!isLoaded) {
    return <FullScreenLoader/>;
  }

  return (<>
    <Outlet/>
    <div className="flex flex-col items-center mt-6">
      <Caption className="text-color-hint">
        {t('system.telegramChannelLinkText')}{' '}
        <a
          href={t('system.telegramChannelLinkUrl')}
          target="_blank"
          rel="noopener noreferrer"
          className="tg-link-color"
          style={{ textDecoration: 'none' }}
        >
          @wishlists
        </a>
      </Caption>
    </div>
  </>);
}
